// #region Imports
import "./styles/index.css";

import App from "./pages/App";
import Dashboard from "./pages/Dashboard";

import { createRoot } from "react-dom/client";

import { BrowserRouter, Routes, Route } from "react-router";
import { PortalProvider } from "./context/PortalProvider";
// #endregion

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
    <>
        <BrowserRouter>
            <PortalProvider>
                <Routes>
                    <Route index element={<App />} />
                    <Route path="*" element={<App />} />
                    <Route path="archive" element={<Dashboard />} />
                </Routes>
            </PortalProvider>
        </BrowserRouter>
    </>,
);
